export const SNAPSHOT = {
  hub: process.env.NEXT_PUBLIC_SNAPSHOT_HUB,
  space: process.env.NEXT_PUBLIC_SNAPSHOT_SPACE,
};
